"use strict";
// This file includes js supporting shortcodes.
// Right now only the `expanding-paragraph` shortcode uses JS.


function getParagraphHeight() {
	var expanding_paragraph = document.querySelectorAll(".expanding-paragraph");
	var expanding_paragraph_inner = document.querySelectorAll(".expanding-paragraph-inner");
	for(var i=0; i<expanding_paragraph.length; i++) {
		expanding_paragraph_inner[i].style.maxHeight = expanding_paragraph_inner[i].offsetHeight + "px";
		expanding_paragraph[i].classList.add("is-closed");
	}
}
window.addEventListener("pageshow", getParagraphHeight);


function getParagraphToggle() {
	var expanding_paragraph_btn = document.querySelectorAll(".expanding-paragraph-button, .expanding-paragraph > h2, .expanding-paragraph > h3, .expanding-paragraph > h4, .expanding-paragraph > h5");

	function toggleParagraph() {
		this.parentNode.classList.toggle("is-closed");
	}

	for(var i=0; i<expanding_paragraph_btn.length; i++) {
		expanding_paragraph_btn[i].addEventListener("click", toggleParagraph.bind(expanding_paragraph_btn[i]), false);
	}
}
window.addEventListener("pageshow", getParagraphToggle);
